var _ = require('lodash');

module.exports = function(fields) {
  var _attrsMapping = {
      id: 'form field name/IDs',
      name: 'form field labels'
    },
    _errors = {};

  var _isValid = function() {
    return _.isEmpty(_getErrors());
  };

  var _errorMessages = function() {
    return _.reduce(
      _getErrors(),
      function(result, msgs) {
        return _.uniq(_.compact([result, [msgs].join(',')])).join(' and ');
      },
      ''
    );
  };

  var _getErrors = function() {
    return _.omit(_errors, _.isEmpty);
  };

  var _setErrors = function(attr, errs) {
    _errors[attr] = errs.join(',');
  };

  var _validateAttribute = function(attr) {
    var errorMsgs = [];
    if (_hasBlank(attr)) {
      errorMsgs.push(["You can not have blank", _attrsMapping[attr]].join(' '));
    } else if (_hasDuplicate(attr)) {
      errorMsgs.push(["You can not have duplicate", _attrsMapping[attr]].join(' '));
    }
    _setErrors(attr, errorMsgs);
  };

  var _hasDuplicate = function(attr) {
    return _.some(
      _.values(
        _.countBy(
          _.map(
            _.pluck(fields, attr), function(val) {
              return val.toLowerCase();
            })
        )
      ),
      function(val) {
        return val > 1;
      }
    );
  };

  var _hasBlank = function(attr) {
    return _.some(
      _.pluck(fields, attr), function(val) {
        return _.isEmpty(_.isString(val) ? val.strip() : val);
      }
    );
  };

  _.forEach(_.keys(_attrsMapping), _validateAttribute);

  return {
    isValid: _isValid,
    errorMessages: _errorMessages
  };
};



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-form/form_builder_validator.js
// module id = 1468
// module chunks = 0